@let item = field();
@let isSelected = !!item.selected;

<div class="page-break-item" [class.disabled]="disabled()" [class.selected]="isSelected">

    <!-- Mesmo vocabulário do card-base: os controles vivem FORA da folha, na
         margem cinza, e só aparecem no hover (ou com o item selecionado). A
         régua fica limpa e alinhada com o texto dos outros cards. -->
    <div class="card-gutter">
        <input
            type="checkbox"
            class="selection-checkbox"
            [class.default-disabled]="disabled()"
            [raEditTooltip]="{ text: ('document.edit.cardBase.selectField' | translate), position: 'bottom' }"
            [(ngModel)]="item.selected"
            [ngModelOptions]="{ standalone: true }"
            (click)="selectItem($event)"
        />

        <div
            cdkDragHandle
            class="drag-handle"
            [class.default-disabled]="disabled()"
            [raEditTooltip]="{ text: ('document.edit.cardBase.dragToReorder' | translate), position: 'bottom' }">
            <ra-icon icon="menu" varColor="currentColor" [size]="16" />
        </div>
    </div>

    <!-- Rail de ações à direita, espelhando o gutter. A quebra só tem uma ação
         (remover), então ela fica direto no rail — sem menu ⋯ para um item só. -->
    <div class="card-toolbar" (click)="$event.stopPropagation()">
        <ra-square-icon
            [backgroundColor]="'white'"
            [icon]="'trash'"
            [type]="'danger'"
            [size]="28"
            [disabled]="disabled()"
            [class.default-disabled]="disabled()"
            [ariaLabel]="'document.edit.pageBreak.remove' | translate"
            [raEditTooltip]="{ text: ('document.edit.pageBreak.remove' | translate), position: 'top' }"
            (click)="!disabled() && remove()"
        />
    </div>

    <span class="rule"></span>

    <span class="tag">
        <ra-icon icon="page-break" varColor="currentColor" [size]="14" />
        {{ 'document.edit.pageBreak.name' | translate }}
    </span>

    <span class="rule"></span>
</div>
